"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "payments",
    path: "/payments",
    component: "Payments"
});
let Payments = class Payments extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItems(...args) {
        if (this.parameters) {
            return this.$fn.fetch('list_payment', { parameters: this.parameters });
        }
        const parameters = this.params;
        return parameters && parameters.account && parameters.date_from
            ? this.$fn.fetch('list_payment', { parameters })
            : [];
    }
    getInvoiceBadgeClass(...args) {
        const data = args[0];
        if (_.isEmpty(data)) {
            return;
        }
        const payment_balance = data.payment_balance || 0;
        const invoice_gross_amount = data.invoice_gross_amount;
        if (payment_balance == 0) {
            return 'bg-green-200';
        }
        if (payment_balance < 0) {
            return 'bg-yellow-200';
        }
        if (payment_balance < invoice_gross_amount) {
            return 'bg-blue-200';
        }
    }
    parameters;
    onParameters(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parameters");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    messages;
    selectedItems;
    params;
    totals;
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$fn.fetch('list_payment_method')
            .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_6466705138206980_headerShowColumnSelectorButton;
    b_6466705138206980_headerShowReloadButton;
    b_6466705138206980_columnDefaults;
    b_6466705138206980_columns;
    async $$load_b_6466705138206980_columns() {
        return [{
                field: "payment_method",
                name: this.$fn.pgettext("PaymentBrowserView", "Method"),
                formatter: {
                    name: "gettext",
                    context: "PaymentMethod",
                    conversion: ["Unsnake",
                        "Sentence",
                    ],
                    filterInput: true,
                },
            },
            {
                field: "transaction_number",
                name: this.$fn.pgettext("PaymentBrowserView", "Number"),
                type: "command",
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "link",
                                href: "#",
                            },
                            {
                                name: "cellclass",
                                value: (row) => ({
                                    'font-weight-bold': true,
                                    'bg-yellow-200': !row.locked
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                field: "transaction_type",
                name: this.$fn.pgettext("PaymentBrowserView", "Type"),
                formatter: {
                    name: "gettext",
                    context: "TransactionType",
                    conversion: "Unsnake",
                    filterInput: true,
                },
            },
            {
                field: "transaction_date",
                name: this.$fn.pgettext("PaymentBrowserView", "Date"),
                type: "date",
            },
            {
                field: "transaction_title",
                name: this.$fn.pgettext("PaymentBrowserView", "Title"),
            },
            {
                field: "transaction_code",
                name: this.$fn.pgettext("PaymentBrowserView", "Transaction code"),
            },
            {
                field: "statement_number",
                name: this.$fn.pgettext("PaymentBrowserView", "Statement number"),
            },
            {
                field: "description",
                name: this.$fn.pgettext("PaymentBrowserView", "Description"),
            },
            {
                field: "notes",
                name: this.$fn.pgettext("PaymentBrowserView", "Message"),
            },
            {
                field: "opening_balance",
                name: this.$fn.pgettext("PaymentBrowserView", "Opening balance"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "amount_in",
                name: this.$fn.pgettext("PaymentBrowserView", "In"),
                type: "number",
                formatter: "number",
            },
            {
                field: "amount_out",
                name: this.$fn.pgettext("PaymentBrowserView", "Out"),
                type: "number",
                formatter: "number",
            },
            {
                field: "closing_balance",
                name: this.$fn.pgettext("PaymentBrowserView", "Closing balance"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "currency",
                name: this.$fn.pgettext("PaymentBrowserView", "Currency"),
            },
            {
                field: "exchange_rate",
                name: this.$fn.pgettext("PaymentBrowserView", "Exchange Rate"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "reference_number",
                name: this.$fn.pgettext("PaymentBrowserView", "Ref Nr."),
            },
            {
                field: "file_number",
                name: this.$fn.pgettext("PaymentBrowserView", "File Nr."),
            },
            {
                field: "client_name",
                name: this.$fn.pgettext("PaymentBrowserView", "Client"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "client_id",
                    },
                },
            },
            {
                field: "invoice_sum_diff",
                name: this.$fn.pgettext("PaymentBrowserView", "Settlement Diff."),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
            {
                field: "invoices",
                name: this.$fn.pgettext("PaymentBrowserView", "Invoices"),
                formatter: [{
                        name: "chain",
                        mode: "mapReduce",
                        separator: ", ",
                        formatterContext: "value",
                        formatters: [{
                                name: "getvalue",
                                opts: {
                                    field: "invoice_number",
                                    source: "value",
                                },
                            },
                            {
                                name: "routeLink",
                                to: "invoice",
                                navigateOnIconClick: true,
                                params: {
                                    id: "id",
                                },
                            },
                            {
                                name: "badge",
                                badgeClass: this.getInvoiceBadgeClass,
                            },
                        ],
                    },
                ],
            },
        ];
    }
    dataMembers = ['messages', 'selectedItems', 'params', 'totals', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings', 'b_6466705138206980_headerShowColumnSelectorButton', 'b_6466705138206980_headerShowReloadButton', 'b_6466705138206980_columnDefaults', 'b_6466705138206980_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: null,
                selectedItems: [],
                params: {},
                totals: [{
                        id: 0,
                        amount_in: 0,
                        amount_out: 0,
                    },
                ],
                paymentMethods: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_6466705138206980_headerShowColumnSelectorButton: false,
                b_6466705138206980_headerShowReloadButton: false,
                b_6466705138206980_columnDefaults: {
                    sortable: false,
                    filterable: true,
                    resizable: true,
                },
                b_6466705138206980_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("PaymentsView", "Payments"),
                icon: this.$config.payment.paymentsList.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4768_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_setData_4770_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_6466705138206980_selectedRowsChanged(event, scope) {
        return await this.actions.evh_6466705138206980_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_showModal_4772_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_6466705138206980_command_4771_getWhen($event) {
        return $event.data.column.id === 'transaction_number';
    }
    async evh_6466705138206980_command(event, scope) {
        return await this.actions.evh_6466705138206980_command.executeFromDOM(this, event, scope);
    }
    async act_2285343489561581_setData_4774_getActionArgs($event) {
        return {
            path: "params",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_2285343489561581_script_4776_getActionArgs_value($event) {
        this.$refs.grid.reload();
    }
    async act_2285343489561581_script_4776_getActionArgs($event) {
        return {
            value: () => this.act_2285343489561581_script_4776_getActionArgs_value($event),
        };
    }
    async evh_2285343489561581_submit(event, scope) {
        return await this.actions.evh_2285343489561581_submit.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4768 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4768_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4767 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4768,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4767],
        });
        const act_6466705138206980_setData_4770 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_4770_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_selectedRowsChanged_4769 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_4770,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_6466705138206980_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_selectedRowsChanged_4769],
        });
        const act_6466705138206980_showModal_4772 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6466705138206980_showModal_4772_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_command_4771 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_showModal_4772,
            event: "command",
            when: this.evh_6466705138206980_command_4771_getWhen,
            displayName: "showModal",
        });
        const evh_6466705138206980_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_command_4771],
        });
        const act_2285343489561581_setData_4774 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2285343489561581_setData_4774_getActionArgs,
            events: [],
        });
        const evh_2285343489561581_submit_4773 = new core_1.actions.EventHandlerImpl({
            action: act_2285343489561581_setData_4774,
            event: "submit",
            displayName: "setData",
        });
        const act_2285343489561581_script_4776 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2285343489561581_script_4776_getActionArgs,
            events: [],
        });
        const evh_2285343489561581_submit_4775 = new core_1.actions.EventHandlerImpl({
            action: act_2285343489561581_script_4776,
            event: "submit",
            displayName: "script",
        });
        const evh_2285343489561581_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2285343489561581_submit_4773, evh_2285343489561581_submit_4775],
        });
        return {
            act_7315092382398562_closeModal_4768,
            evh_7315092382398562_close_4767,
            evh_7315092382398562_close,
            act_6466705138206980_setData_4770,
            evh_6466705138206980_selectedRowsChanged_4769,
            evh_6466705138206980_selectedRowsChanged,
            act_6466705138206980_showModal_4772,
            evh_6466705138206980_command_4771,
            evh_6466705138206980_command,
            act_2285343489561581_setData_4774,
            evh_2285343489561581_submit_4773,
            act_2285343489561581_script_4776,
            evh_2285343489561581_submit_4775,
            evh_2285343489561581_submit,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], Payments.prototype, "parameters", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parameters'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payments.prototype, "onParameters", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Payments.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Payments.prototype, "onSize", null);
Payments = __decorate([
    (0, vue_property_decorator_1.Component)()
], Payments);
exports.default = Payments;
vue_property_decorator_1.Vue.component("Payments", Payments);
